export default "__VITE_ASSET__83c8c644__"